import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const RoleCard = ({ role }) => {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  const handleEnter = () => {
    if (role?.path) {
      navigate(role?.path);
    }
  };

  return (
    <div
      className={`relative bg-white rounded-2xl p-8 cursor-pointer transition-all duration-300 border-2 flex flex-col h-full ${
        hovered
          ? 'border-[var(--color-primary)] shadow-warm-xl -translate-y-2'
          : 'border-[var(--color-border)] shadow-warm-md'
      }`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleEnter}
    >
      <div
        className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-5 transition-all duration-300 ${
          hovered ? 'scale-110' : ''
        }`}
        style={{ background: role?.gradient }}
      >
        <span className="text-3xl">{role?.icon}</span>
      </div>
      <h3 className="text-xl font-bold text-[var(--color-foreground)] mb-2" style={{ fontFamily: 'Crimson Text, serif' }}>
        {role?.title}
      </h3>
      <p className="text-[var(--color-muted-foreground)] text-sm mb-5 leading-relaxed">
        {role?.description}
      </p>
      <ul className={`space-y-2 mb-6 flex-1 transition-all duration-300 ${hovered ? 'opacity-100' : 'opacity-60'}`}>
        {role?.features?.map((feature, idx) => (
          <li key={idx} className="flex items-center gap-2 text-sm text-[var(--color-card-foreground)]">
            <span
              className="w-5 h-5 rounded-full flex items-center justify-center text-white text-xs flex-shrink-0"
              style={{ background: role?.accentColor }}
            >
              ✓
            </span>
            {feature}
          </li>
        ))}
      </ul>
      <button
        className="w-full py-3 px-6 rounded-xl font-semibold text-sm transition-all duration-300 text-white"
        style={{
          background: hovered ? role?.accentColor : role?.gradient,
          boxShadow: hovered ? `0 8px 20px ${role?.shadowColor}` : 'none',
        }}
        onClick={(e) => {
          e?.stopPropagation();
          handleEnter();
        }}
      >
        Enter as {role?.title}
      </button>
    </div>
  );
};

export default RoleCard;
